import { useQuery } from 'react-query';

import { getViewRivalMl } from '@/services/minileagues';
import { ResponseVerEquiposML } from '@/types/minileagues';
import { GENERICS_WORDS } from '@/utils';

export const useGetTeams = (id: number, order: number, enabled: boolean) => {
  const { isLoading, data, refetch, isFetching } = useQuery(
    'RequestViewRivalMinileagues',
    async () => await getViewRivalMl(id, order),
    {
      onSuccess: async (response: ResponseVerEquiposML) => {
        if (!response.estado && response.codError) {
          console.error(`Error: ${response.mensaje}.`);
        }
      },
      onError: (error) => {
        console.error(
          `Error obteniendo datos de ${GENERICS_WORDS.minileagues}.`,
          error
        );
        throw new Error('Invalid response state');
      },
      refetchOnWindowFocus: false,
      keepPreviousData: false,
      enabled,
    }
  );

  return { isLoading, data, refetch, isFetching };
};
